import LawyerDetail from './lawyer-detail'
export default [
  {
    path: '/lawyerDetail',
    name: 'lawyer-detail',
    component: LawyerDetail
  }
]



// WEBPACK FOOTER //
// ./src/components/lawyer-detail/lawyer-detail-router.js